<img [src]="imageSrc" [alt]="imageAltText" loading="lazy">